import { getStore } from "app/store/store"
import { IForm, IFormDataLoader } from "form/model"
import { formActionCreator } from "form/store/actions"
import { IUserTag } from "user-tag/model"
import { tagRPO } from "user-tag/repository"
import { getAllUserTagsInStore } from "user-tag/tools/common"

export const tagsFormDataLoader: IFormDataLoader = async (form: IForm, onFinish: (error?: string) => any) => {
  try {
    const userTags = await tagRPO.getAllUserTagsForCampaign(form.tempCampaignId)
    form.context.relations.userTags = userTags
    form.configuration.main.userTagIds = userTags.map(t => t.id)
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Tags data-loader error ${String(error)}`)
  }
}

export async function synchronizeUserTags(form: IForm): Promise<void> {
  const { tempCampaignId: campaignId } = form
  const { userTags: existingUserTags } = form.context.relations
  const { userTagIds: toSetUserTagIds } = form.configuration.main
  if (typeof campaignId !== "number") {
    return Promise.reject("campaignId must be a number")
  }
  if (campaignId < 0) {
    return Promise.reject("campaignId must be equals or greater then 0")
  }
  if (!Array.isArray(toSetUserTagIds)) {
    return Promise.reject("userTagIds must be an array")
  }
  const allUserTags = getAllUserTagsInStore()
  for (const toSetUserTagId of toSetUserTagIds) {
    if (!allUserTags.find(t => t.id === toSetUserTagId)) {
      return Promise.reject(`User tag id="${toSetUserTagId}" not found`)
    }
  }
  if (Array.isArray(existingUserTags)) {
    for (const existingUserTag of existingUserTags) {
      if (typeof existingUserTag !== "object") {
        return Promise.reject("An existing user tag is invalid")
      }
    }
  }
  let hasError: boolean = false
  let serverSideUserTags: IUserTag[] = []
  for (const toSetUserTagId of toSetUserTagIds) {
    const existingTag = !existingUserTags ? undefined : existingUserTags.find(t => t.id === toSetUserTagId)
    if (!existingTag) {
      try {
        const userTag = allUserTags.find(t => t.id === toSetUserTagId)
        if (!userTag) {
          hasError = true
          console.error("Unable to found user tag id=", toSetUserTagId)
          continue
        }
        serverSideUserTags.push(await tagRPO.associateUserTagToCampaign(campaignId, userTag))
      } catch (error) {
        hasError = true
        console.error("Unable to associate user tag to campaign", error)
      }
    } else {
      serverSideUserTags.push(existingTag)
    }
  }
  if (existingUserTags) {
    for (const existingUserTag of existingUserTags) {
      if (!toSetUserTagIds.includes(existingUserTag.id)) {
        try {
          await tagRPO.deassociateUserTagToCampaign(campaignId, existingUserTag.id)
        } catch (error) {
          hasError = true
          console.error("Unable to deassociate tag to campaign", error)
          serverSideUserTags.push(existingUserTag)
        }
      }
    }
  }
  if (hasError) {
    try {
      serverSideUserTags = await tagRPO.getAllUserTagsForCampaign(form.tempCampaignId)
    } catch (error) {
      // it doesn't smell good here ...
      console.error("Cannot fallback ...", error)
      return
    }
  }
  getStore().dispatch(
    formActionCreator.setRelations(form.context.appContext, { userTags: serverSideUserTags, userTagsError: hasError })
  )
}
